import { DatePipe, DecimalPipe } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
    inject,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { Subject, takeUntil } from 'rxjs';
import { RemoveCommaPipe } from '../../../features/pipes/remove-comma.pipe';
import { PopoverDirective } from '../../../features/popover/popover.directive';

@Component({
    selector: 'credits',
    templateUrl: './credits.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatIconModule,
        TranslocoPipe,
        DatePipe,
        DecimalPipe,
        RemoveCommaPipe,
        PopoverDirective,
        RouterLink,
    ],
})
export class CreditsComponent implements OnInit, OnDestroy {
    user: User;
    userService = inject(UserService);
    cd = inject(ChangeDetectorRef);
    private unsubscribeAll: Subject<any> = new Subject<any>();

    ngOnInit(): void {
        this.userService.authUser$
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe({
                next: (user: User) => {
                    this.user = user;
                    this.cd.detectChanges();
                },
            });
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.next(null);
        this.unsubscribeAll.complete();
    }
}
